export enum DocumentLogSource {
  Camera = "camera",
  Files = "files",
  Gallery = "gallery",
  Whatsapp = "whatsapp",
  Email = "email",
}

export enum DocumentLogStatus {
  Processing = "Processing",
  Uncategorized = "Uncategorized",
  Assigned = "Assigned",
  Deleted = "Deleted",
  UploadFailed = "UploadFailed",
  Duplicate = "Duplicate",
}

// Helper function to get translated document log source labels
export const getDocumentLogSourceLabel = (
  source: DocumentLogSource,
  t: (key: string) => string
): string => {
  return t(`common.documentLogSource.${source}`);
};

export const DOCUMENT_LOG_STATUS_LABELS: Record<DocumentLogStatus, string> = {
  [DocumentLogStatus.Processing]: "Processing",
  [DocumentLogStatus.Uncategorized]: "Review",
  [DocumentLogStatus.Assigned]: "Processed",
  [DocumentLogStatus.Deleted]: "Deleted",
  [DocumentLogStatus.UploadFailed]: "Upload Failed",
  [DocumentLogStatus.Duplicate]: "Duplicate",
};

export const DOCUMENT_LOG_STATUS_COLORS: Record<
  DocumentLogStatus,
  "grey" | "red" | "yellow" | "orange"
> = {
  [DocumentLogStatus.Deleted]: "grey",
  [DocumentLogStatus.Processing]: "yellow",
  [DocumentLogStatus.Uncategorized]: "orange",
  [DocumentLogStatus.Assigned]: "orange",
  [DocumentLogStatus.UploadFailed]: "red",
  [DocumentLogStatus.Duplicate]: "grey",
};
